export enum RouteNames {
  productSearch = 'product-search',
  cart = 'cart',
  product = 'product',
  notFound = 'not-found',
  landing = 'overview'
}